import React from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

const Admin = ({ title1, title2, blocks, image }) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  return (
    <Grid container spacing={4} direction={isMd ? "row" : "column-reverse"}>
      <Grid item xs={12} md={6} data-aos={isMd ? "fade-right" : "fade-up"}>
        <Box marginTop={7}>
          <Box
            component={Typography}
            fontWeight={700}
            variant={"h4"}
            gutterBottom
          >
            <Typography color="primary" variant="inherit" component="span">
              {title1}
            </Typography>{" "}
            {title2}
          </Box>
        </Box>
        <List>
          {blocks.map((item, index) => (
            <ListItem key={index} disableGutters data-aos="fade-up">
              <ListItemText
                primary={<Typography variant={"h6"} component="h5">{item.title}</Typography>}
                secondary={
                  <Typography variant={"body1"} color="text.secondary">
                    {item.subtitle}
                  </Typography>
                }
              />
            </ListItem>
          ))}
        </List>
      </Grid>

      <Grid
        item
        container
        justifyContent="center"
        alignItems="center"
        xs={12}
        md={6}
        data-aos={isMd ? "fade-left" : "fade-up"}
      >
        <Box width={"100%"}>{image}</Box>
      </Grid>
    </Grid>
  );
};

export default Admin;
